import { Skeleton } from 'antd';

export default function BookingCardSkeleton() {
  return (
    <div
      style={{
        borderRadius: 16,
        background: 'var(--bl-surface, #fff)',
        boxShadow: 'var(--bl-shadow-soft, 0 2px 10px rgba(0,0,0,0.06))',
        margin: '0 16px 10px',
        overflow: 'hidden',
      }}
    >
      {/* Top strip */}
      <div
        style={{
          height: 3,
          background: 'var(--bl-surface-soft, #f0f2f5)',
        }}
      />

      <div style={{ padding: '12px 14px 14px' }}>
        {/* Row 1: time + status */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 10,
          }}
        >
          <Skeleton.Input active size="small" style={{ width: 110, height: 16 }} />
          <Skeleton.Input active size="small" style={{ width: 78, height: 20, borderRadius: 20 }} />
        </div>

        {/* Row 2: avatar + texts + amount */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, flex: 1 }}>
            <Skeleton.Avatar active size={36} shape="circle" />
            <div style={{ display: 'flex', flexDirection: 'column', gap: 5, flex: 1 }}>
              <Skeleton.Input active size="small" style={{ width: 130, height: 14 }} />
              <Skeleton.Input active size="small" style={{ width: 90, height: 11 }} />
            </div>
          </div>
          <Skeleton.Input active size="small" style={{ width: 80, height: 18 }} />
        </div>
      </div>
    </div>
  );
}
